import React from "react";
import { Facebook, Youtube, Mail } from "lucide-react";
import { bandData } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10 py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_searching-fusion/artifacts/fho35rrj_Screenshot_20250629_143145_Facebook.png"
                alt="Searching Fusion Logo"
                className="h-12 w-12 rounded-full object-cover"
              />
              <h3 className="text-xl font-bold text-white">{bandData.name}</h3>
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              Power trio from {bandData.location} bringing high-energy fusion to stages everywhere.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="#about"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById("about")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="text-white/60 hover:text-[#00d9ff] text-sm"
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="#members"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById("members")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="text-white/60 hover:text-[#00d9ff] text-sm"
                >
                  Members
                </a>
              </li>
              <li>
                <a
                  href="#shows"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById("shows")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="text-white/60 hover:text-[#00d9ff] text-sm"
                >
                  Shows
                </a>
              </li>
              <li>
                <a
                  href="#booking"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="text-white/60 hover:text-[#00d9ff] text-sm"
                >
                  Book Us
                </a>
              </li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h4 className="text-white font-bold mb-4">Connect With Us</h4>
            <div className="space-y-3 mb-4">
              <a
                href={`mailto:${bandData.email}`}
                className="flex items-center gap-2 text-white/60 hover:text-[#00d9ff] text-sm"
              >
                <Mail size={16} />
                {bandData.email}
              </a>
            </div>
            <div className="flex gap-4">
              <a
                href={bandData.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#1877f2] hover:bg-[#145dbf] rounded-full flex items-center justify-center"
                aria-label="Facebook"
              >
                <Facebook size={20} className="text-white" />
              </a>
              <a
                href={bandData.social.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#ff0000] hover:bg-[#cc0000] rounded-full flex items-center justify-center"
                aria-label="YouTube"
              >
                <Youtube size={20} className="text-white" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 text-center">
          <p className="text-white/60 text-sm">
            © {new Date().getFullYear()} {bandData.name}. All rights reserved.
          </p>
          <p className="text-white/40 text-xs mt-2">
            Established {bandData.foundedYear} • {bandData.location}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
